<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="500px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="receiptTransferForm"
      v-loading="loading"
      :model="receiptTransfer"
      :rules="rules"
      label-position="top"
      autocomplete="off"
      style="margin-bottom: 30px;"
      @submit.native.prevent="store"
    >
      <el-form-item
        prop="source_storage_id"
        label="Forrás raktár"
      >
        <el-select
          v-model="receiptTransfer.source_storage_id"
          :disabled="type === 'update'"
          style="width: 100%;"
          filterable
          default-first-option
        >
          <el-option
            v-for="storage in storages"
            :key="storage.id"
            :label="storage.name"
            :value="storage.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        prop="target_storage_id"
        label="Cél raktár"
      >
        <el-select
          v-model="receiptTransfer.target_storage_id"
          :disabled="type === 'update'"
          style="width: 100%;"
          filterable
          default-first-option
        >
          <el-option
            v-for="storage in storages"
            :key="storage.id"
            :label="storage.name"
            :value="storage.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        prop="type"
        label="Típus"
      >
        <el-select
          v-model="receiptTransfer.type"
          :disabled="type === 'update'"
          style="width: 100%;"
          placeholder="Válassz típust..."
          :default-first-option="true"
          :filterable="true"
        >
          <el-option
            v-for="transferType in transferTypes"
            :key="transferType.label"
            :label="transferType.label"
            :value="transferType.value"
          />
        </el-select>
      </el-form-item>
      <el-row
        v-if="receiptTransfer.type === 2"
        :gutter="20"
      >
        <el-col :span="10">
          <el-form-item
            prop="start_date"
            label="Kezdés dátuma"
          >
            <el-date-picker
              v-model="receiptTransfer.start_date"
              type="date"
              style="width: 100%;"
              :clearable="false"
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            prop="end_date"
            label="Befejezés dátuma"
          >
            <el-date-picker
              v-model="receiptTransfer.end_date"
              type="date"
              style="width: 100%;"
              :clearable="false"
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        v-if="receiptTransfer.type === 1"
        prop="receipts"
        label="Bizonylatok"
      >
        <el-select
          v-model="receiptTransfer.receipts"
          :disabled="type === 'update' || !receiptTransfer.source_storage_id"
          style="width: 100%;"
          filterable
          remote
          :remote-method="searchReceipts"
          :loading="receiptLoading"
          placeholder="Gépelj a kereséshez..."
          multiple
        >
          <el-option
            v-for="receipt in receipts"
            :key="receipt.receipt_number"
            :label="receipt.receipt_number"
            :value="receipt.receipt_number"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <div>
        <el-button @click="handleClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          :loading="buttonLoading"
          @click="store"
        >
          {{ buttonText }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['type', 'receiptTransferId'],
  data() {
     const validateDate = (rule, value, callback) => {
      if (this.receiptTransfer.type === 2 && !value) {
        return callback(new Error('Mező kitöltése kötelező'))
      }
        return callback()
    }
    return {
      loading: false,
      buttonLoading: false,
      receiptLoading: false,
      receipts: [],
      receiptTransfer: {
      },
      transferTypes: [
        {
          label: 'Manuális',
          value: 1
        },
        {
          label: 'Automatikus',
          value: 2
        },
      ],
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate (date) {
          const dateObject = new Date();
          dateObject.setDate(dateObject.getDate() - 1)
          return date <= dateObject;
        }
      },

      rules: {
        source_storage_id: [
          {
            required: true,
            message: 'Mező kitöltése kötelező',
            trigger: 'change'
          }
        ],
        target_storage_id: [
          {
            required: true,
            message: 'Mező kitöltése kötelező',
            trigger: 'change'
          }
        ],
        type: [
          {
            required: true,
            message: 'Típus választása kötelező',
            trigger: 'change'
          }
        ],
        start_date: [
          { validator: validateDate, trigger: 'change'}
        ],
        end_date: [
          { validator: validateDate, trigger: 'change'}
        ]
      },
    };
  },
  computed: {
    storages() {
      return this.$store.getters['storage/storages'];
    },
    users() {
      return this.$store.getters['user/users'];
    },
    title() {
      if (this.type === 'add') {
        return 'Új bizonylat áthelyezés';
      } else if (this.type === 'update') {
        return 'Bizonylat áthelyezés módosítása';
      } else {
        return '';
      }
    },
    buttonText() {
      if (this.type === 'add') {
        return 'Áthelyezés';
      } else if (this.type === 'update') {
        return 'Módosítás';
      } else {
        return '';
      }
    },
  },
  async mounted() {
    this.loading = true;
    const requiredFetches = [];
    if (!this.users.length) {
      requiredFetches.push(this.$store.dispatch('user/fetchAll'));
    }
    if (!this.storages.length) {
      requiredFetches.push(this.$store.dispatch('storage/fetchAll'));
    }
    await Promise.all(requiredFetches);
    if (this.receiptTransferId) {
      this.receiptTransfer = await this.$store.dispatch('receiptTransfer/fetch', this.receiptTransferId);
    }
    this.loading = false;
  },
  methods: {
    async searchReceipts(query) {
      this.receiptLoading = true;
      if (!query) {
        // this.receipts = [];
      } else {
        this.receipts = await axios.get(`api/receipt-transfers/receipts/${this.receiptTransfer.source_storage_id}/${query}`)
      }
      this.receiptLoading = false;
    },
    handleClose() {
      this.$confirm('Biztosan elveted a módosításokat?', {
        confirmButtonText: 'Igen',
        type: 'warning',
      })
        .then(() => {
          this.$router.replace('/representative-processes/receipt-transfers');
        })
        .catch(() => {
        });
    },
    async store() {
      this.$refs['receiptTransferForm'].validate(async valid => {
        if (valid) {
          this.buttonLoading = true;
          try {
            if (this.type === 'add') {
              await this.$store.dispatch('receiptTransfer/create', this.receiptTransfer);
            } else {
              await this.$store.dispatch('receiptTransfer/update', this.receiptTransfer);
            }
            this.$store.dispatch('receiptTransfer/fetchAll');
            this.$router.replace('/representative-processes/receipt-transfers');
          } catch (e) {
          }
          this.buttonLoading = false;
        }
      });
    },
  }
};
</script>
